import config from 'libs/config.js';

import { GetModules, CheckModules } from '@/libs/license.js';

export default {
  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install(Vue) {
    // ES6 way of const job = options.job
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$authorizeModule = async modulekey => {
      let modules = await CheckModules();

      let value = modules[modulekey];
      return value;
    };
  }
};
